import { render } from "./BdcomGponPonTable.vue?vue&type=template&id=5d8fea38"
import script from "./BdcomGponPonTable.vue?vue&type=script&lang=js"
export * from "./BdcomGponPonTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__